import { createContext, useContext } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';

const Context = createContext(null);

export const createAppStore = (props) => {
  return {
    isShowConfirmCreateEventModal: false,
    setIsShowConfirmCreateEventModal: function () {
      this.isShowConfirmCreateEventModal = true;
    },
    currentUserId: null,
    setCurrentUserId: function (userId) {
      this.currentUserId = userId;
    },
    passedOnBoarding: true,
    setPassedOnBoarding: function (value) {
      this.passedOnBoarding = value;
    },
    maxFileSize: 2 * 1024 * 1024,
    setMaxFileSize: function (value) {
      this.maxFileSize = value;
    },
    addToChatEnabled: false,
    setAddToChatEnabled: function (value) {
      this.addToChatEnabled = value;
    },
    generateEventImageEnabled: false,
    setGenerateEventImageEnabled: function (value) {
      this.generateEventImageEnabled = value;
    },
    isShowCheckQrCodeScan: false,
    setIsShowCheckQrCodeScan: function (value) {
      this.isShowCheckQrCodeScan = value;
    },
    remainingReceiptScansCount: 0,
    setRemainingReceiptScansCount: function (value) {
      this.remainingReceiptScansCount = value;
    },
    remainingEventsCount: 0,
    setRemainingEventsCount: function (value) {
      this.remainingEventsCount = value;
    },
    isShowConfirmShareLink: false,
    setIsShowConfirmShareLink: function (value) {
      this.isShowConfirmShareLink = value;
    },
    userEvents: {events:[], count:0},
    setUserEvents: function (events, count) {
      this.userEvents = {
        events,
        count
      };
    },
    addUserEvents: function (events, count) {
      this.userEvents.events = [...this.userEvents.events, ...events];
      if (count) {
        this.userEvents.count = count;
      }
    },
    isEnabledScanReceipt: false,
    setIsEnabledScanReceipt: function (value) {
      this.isEnabledScanReceipt = value;
    },
    scanReceiptsCache: {},
    setScanReceiptsCache: function (eventId, total, items) {
      this.scanReceiptsCache[eventId] = {
        total: total,
        items: items,
      };
    },
    getScanReceiptsCache: function (eventId) {
      return this.scanReceiptsCache[eventId] || null;
    },
    clearScanReceiptsCache: function (eventId) {
      this.scanReceiptsCache[eventId] = null;
    },
  }
}

export const AppStoreProvider = observer(({ children, ...props }) => {
  const store = useLocalObservable(() => createAppStore(props));

  return <Context.Provider value={store}>{children}</Context.Provider>;
})

export const useAppStore = () => {
  const store = useContext(Context);

  if (!store) {
    throw new Error('Use App store within provider!');
  }

  return store;
}
